<div class="mam-explorer">
  <header class="mam-explorer__header">
    <h1 class="mam-explorer__title">Media Asset Management</h1>
  </header>

  <evrideo-mam-explorer-toolbar
    [searchQuery]="state.searchQuery()"
    [statusFilter]="state.statusFilter()"
    (searchChange)="onSearchChange($event)"
    (statusFilterChange)="onStatusFilterChange($event)"
    (uploadClick)="onUploadClick()"
    (exportClick)="onExportClick()"
  ></evrideo-mam-explorer-toolbar>

  <div class="mam-explorer__grid-container">
    <evrideo-ag-grid-evrideo-header [selectedCount]="selectedTableItemsCount">
      <div
        [class.button-disabled]="!selectedTableItemsCount"
        class="mam-explorer__bulk-btn"
        title="Download Selected"
        (click)="selectedTableItemsCount && onBulkDownload()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" fill="currentColor" />
        </svg>
        <span>Download</span>
      </div>
      <div
        [class.button-disabled]="!selectedTableItemsCount"
        class="mam-explorer__bulk-btn"
        title="Export Metadata"
        (click)="selectedTableItemsCount && onBulkExportMetadata()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" fill="currentColor" />
        </svg>
        <span>Export Metadata</span>
      </div>
      <div
        [class.button-disabled]="!selectedTableItemsCount"
        class="mam-explorer__bulk-btn"
        title="Edit in Studio"
        (click)="selectedTableItemsCount && onBulkEditInStudio()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="currentColor" />
        </svg>
        <span>Edit in Studio</span>
      </div>
      <div
        [class.button-disabled]="!selectedTableItemsCount"
        class="mam-explorer__bulk-btn"
        title="Delete Selected"
        (click)="selectedTableItemsCount && onBulkDelete()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z" fill="currentColor" />
        </svg>
        <span>Delete</span>
      </div>
    </evrideo-ag-grid-evrideo-header>

    <ag-grid-angular
      #mamGrid
      class="ag-theme-balham ag-theme-evrideo"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      [gridOptions]="gridOptions"
    ></ag-grid-angular>
  </div>
</div>
